import type { Submission } from './types.ts';
import { expiryState } from './expiry.ts';

export type UploadDocStats = { current: number; expiring: number; expired: number };

// Tally a vendor's live uploaded files by expiry health, using the shared
// expiryState() helper so the Home stat card and the Documents summary chips
// always agree with the per-file chips. Counted per FILE (the admin-side
// complianceDocStats counts per question row, a different granularity).
// Adoptions are not counted — they carry no expiry. The /api/me read paths
// already exclude superseded files; the filter here is defensive.
export function uploadDocStats(submissions: Submission[], now: Date = new Date()): UploadDocStats {
  const stats: UploadDocStats = { current: 0, expiring: 0, expired: 0 };
  for (const s of submissions) {
    for (const f of s.submission_files) {
      if (f.superseded_at) continue;
      switch (expiryState(f, now)) {
        case 'expired':
          stats.expired += 1;
          break;
        case 'expiring':
          stats.expiring += 1;
          break;
        default: // 'ok' | 'none' — provided and healthy
          stats.current += 1;
      }
    }
  }
  return stats;
}
